import React, { useCallback, useMemo } from 'react';
import { ValidatedTargetDevices } from '@bingads-webui-campaign-react/sponsored-campaign-creation';
import { withCustomValidation } from '@bingads-webui-react/validation';

export const convertToGridTargetDetails = devices => ({
  useParentLevel: false,
  parentLevelSettings: [],
  currentLevelSettings: devices ? devices.map(({
    device, bidAdjustment, Id, isBidAdjustmentNegative,
  }) => ({
    targeted: _TL_('Targeted'),
    device,
    bidAdjustmentDropdown: isBidAdjustmentNegative ? _TL_('Decrease by') : _TL_('Increase by'),
    bidAdjustmentInput: Math.abs(bidAdjustment),
    Id,
  })) : [],
});

const convertFromGridTargetDetails = device => ({
  devices: device && device.currentLevelSettings && Array.isArray(device.currentLevelSettings) ?
    device.currentLevelSettings.map(({
      device: deviceName, bidAdjustmentDropdown, bidAdjustmentInput, Id,
    }) => {
      const isBidAdjustmentNegative = bidAdjustmentDropdown === 'Decrease by';

      return {
        device: deviceName,
        bidAdjustment: parseFloat(bidAdjustmentInput),
        // Needs another boolean to indicate the dropdown selection.
        // If we use `bidAdjustment < 0`, users cannot change the dropdown when the bidAdjustment is 0
        isBidAdjustmentNegative,
        Id,
      };
    }) : [],
});

const InternalDeviceTargets = ({
  validationProps, updateValidation, ...restProps
}) => {
  const { data: deviceTargets } = validationProps;

  const onChange = useCallback((errors, newData) => {
    const { device } = newData || {};
    updateValidation(errors, convertFromGridTargetDetails(device));
  }, [updateValidation]);

  const mappedData = useMemo(() => convertToGridTargetDetails(deviceTargets), [deviceTargets]);

  return (<ValidatedTargetDevices
    validationProps={{
    data: mappedData,
  }}
    updateValidation={onChange}
    {...restProps}
  />);
};

export const DeviceTargets = withCustomValidation(InternalDeviceTargets);

